// Test IDs for "The Catalyst Table" landing and admin feature.
export const HOME = {
  emergentLink: 'home-emergent-link',
  
  // Navigation
  navStoryLink: 'nav-story-link',
  navExpectLink: 'nav-expect-link',
  navExperienceLink: 'nav-experience-link',
  navDinnersLink: 'nav-dinners-link',
  navWaitlistLink: 'nav-waitlist-link',
  navNominateLink: 'nav-nominate-link',
  navAdminLink: 'nav-admin-link',

  // Hero CTAs
  heroJoinButton: 'hero-join-waitlist-button',
  heroNominateButton: 'hero-nominate-button',

  // Waitlist Form
  waitlistForm: 'waitlist-form',
  waitlistFirstName: 'waitlist-first-name-input',
  waitlistLastName: 'waitlist-last-name-input',
  waitlistEmail: 'waitlist-email-input',
  waitlistOrganisation: 'waitlist-organisation-input',
  waitlistRole: 'waitlist-role-input',
  waitlistSector: 'waitlist-sector-input',
  waitlistLinkedin: 'waitlist-linkedin-input',
  waitlistWhyJoin: 'waitlist-why-join-input',
  waitlistWhatBrings: 'waitlist-what-brings-input',
  waitlistSubmit: 'waitlist-submit-button',

  // Nomination Form
  nominateForm: 'nominate-form',
  nominateNominatorName: 'nominate-nominator-name-input',
  nominateNominatorEmail: 'nominate-nominator-email-input',
  nominateNomineeName: 'nominate-nominee-name-input',
  nominateOrganisation: 'nominate-organisation-input',
  nominateWhyNominate: 'nominate-why-nominate-input',
  nominateSubmit: 'nominate-submit-button',

  // Admin Dashboard
  dashboardContainer: 'admin-dashboard-container',
  dashboardWaitlistTable: 'dashboard-waitlist-table',
  dashboardNominationsTable: 'dashboard-nominations-table',
  dashboardEmailLogsTable: 'dashboard-email-logs-table',
  dashboardExportWaitlist: 'dashboard-export-waitlist-button',
  dashboardExportNominations: 'dashboard-export-nominations-button',
  dashboardDinnersTab: 'dashboard-dinners-tab',
  dashboardAddDinner: 'dashboard-add-dinner-button',
  dashboardDinnerSave: 'dashboard-dinner-save-button',
  logoutButton: 'logout-button',
};
